export default __webpack_public_path__ + "justhatched-second-screens_small@2x.4673731e.png";